import { refreshScrollTriggers } from 'helpers/helpers'

const alertBanner = {
  el: {
    alertBanner: document.querySelector('.alert-banner'),
    alertClose: document.querySelector('.alert-banner__close'),
    header: document.querySelector('.header'),
  },
  init() {
    if (!this.el.alertBanner) {
      return
    }

    if (sessionStorage.getItem('alert-hide')) {
      this.el.alertBanner.classList.add('hidden')
      if (this.el.alertBanner.classList.contains('mt-20 md:mt-20')) {
        this.el.header.classList.remove('mt-20 md:mt-20')
        refreshScrollTriggers()
      }
    }

    if (this.el.alertClose) {
      this.el.alertClose.addEventListener('click', () => {
        this.el.alertBanner.classList.add('hidden')
        sessionStorage.setItem('alert-hide', 'true')
        refreshScrollTriggers()
      })
    }
  },
}

export default alertBanner
